import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestAttachmentGet = {
    path: "/attachments/:id",
    method: RouteHttpVerb.GET
};
export { locationRestAttachmentGet };
